import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button.tsx";
import { useLoginAuthStore } from "@/lib/hooks/use-login-auth-store";
import { useState } from "react";
import { Loader2 } from "lucide-react";

interface UserAuthProps {
  onAuthenticate: (email: string, password: string) => void;
}
export function UserAuth({ onAuthenticate }: UserAuthProps) {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const { email, password, setEmail, setPassword } = useLoginAuthStore();

  const handleAuthenticate = async () => {
    setLoading(true);
    try {
      await onAuthenticate(email, password);
    } catch (e) {
      console.error(e);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <Input
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setError(null);
        }}
        placeholder="Enter your email"
        className="h-12 rounded-[12px] border-[#e3dbcf] bg-[#faf4ea] text-sm placeholder:text-[#b4aa9a] focus-visible:ring-2 focus-visible:ring-black/5"
      />
      <Input
        value={password}
        type="password"
        onChange={(e) => {
          setPassword(e.target.value);
          setError(null);
        }}
        placeholder="Enter your password"
        className="h-12 rounded-[12px] border-[#e3dbcf] bg-[#faf4ea] text-sm placeholder:text-[#b4aa9a] focus-visible:ring-2 focus-visible:ring-black/5"
      />

      <Button
        onClick={handleAuthenticate}
        className="mt-2 h-12 w-full rounded-[12px] bg-black text-sm font-semibold text-white hover:bg-black/90"
        disabled={loading}
      >
        {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Log in
      </Button>

      {error && <div className="text-sm text-red-500">{error}</div>}
    </div>
  );
}
